var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("图表介绍")]),
      _vm._v(" "),
      _c("p", [_vm._v("Gauge， 仪表盘。")]),
      _vm._v(" "),
      _c("h3", [_vm._v("attrs")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("属性名")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("title")]),
            _vm._v(" "),
            _c("td", [_vm._v("String | Function")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("d => d")])]),
            _vm._v(" "),
            _c("td", [_vm._v("标题")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("min")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("0")])]),
            _vm._v(" "),
            _c("td", [_vm._v("最小值")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("max")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("1")])]),
            _vm._v(" "),
            _c("td", [_vm._v("最大值")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("startAngle")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("140")]),
            _vm._v(" "),
            _c("td", [_vm._v("起始角度")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("endAngle")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("400")]),
            _vm._v(" "),
            _c("td", [_vm._v("结束角度")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("strokeBgcolor")]),
            _vm._v(" "),
            _c("td", [_vm._v("String")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("#eee")])]),
            _vm._v(" "),
            _c("td", [_vm._v("背景色")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("lineWidth")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("0")])]),
            _vm._v(" "),
            _c("td", [_vm._v("弧线宽度")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("lineCap")]),
            _vm._v(" "),
            _c("td", [_vm._v("String")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("round")])]),
            _vm._v(" "),
            _c("td", [_vm._v("弧线线帽")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("tickStep")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("0.1")])]),
            _vm._v(" "),
            _c("td", [
              _vm._v("tick 步进，生成 tick 的数量为 "),
              _c("code", { pre: true }, [_vm._v("(max - min) / tickStep")])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("tickLength")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("5")])]),
            _vm._v(" "),
            _c("td", [_vm._v("刻度长度，为负值时向外绘制")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("labelOffset")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("5")])]),
            _vm._v(" "),
            _c("td", [_vm._v("刻度上文字与刻度线距离")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("tickFormatter")]),
            _vm._v(" "),
            _c("td", [_vm._v("Function")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("d => d")])]),
            _vm._v(" "),
            _c("td", [_vm._v("刻度文本格式化")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("style")]),
      _vm._v(" "),
      _c("p", [_vm._v("组件中可以自定义 css 属性的元素如下表：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基础类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("arc")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("弧线样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("pointer")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("仪表盘指针")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("title")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("标题样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("tickLine")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("刻度线样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("tickText")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("刻度文字样式")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }